jQuery(document).ready(function ($) {
  $('#intersitial-close-button').on('click', function(){
   closeIntersitial();
  });


  $(this).on('click', function (e) {
    var element = $('#intersitial-modal')

    console.log("elemento: " + element.attr("id"))
    console.log("target: "   + e.target.id)

    if (e.target.id === element.attr("id")) {
      closeIntersitial()
    }
  })

  // thereIsAlteredCampaigns(function (restartIntervention) {
  //   if(restartIntervention && $('#intersitial-modal').length > 0){
  //     $('#intersitial-modal').css('display', 'block');
  //     window.parent.$('body').css('overflow', 'hidden');
  //     sessionStorage.setItem('restart-intervention', 'false')
  //     IntersitialInterventionEventOpen();
  //   } else {
  //     $('#intersitial-modal').css('display', 'none');
  //     $("#intersitial-iframe", parent.document.body).css('zIndex', -1);
  //   }
  // });

  function closeIntersitial() {
    $('#intersitial-modal').css('display', 'none');
    $("#intersitial-iframe", parent.document.body).css('zIndex', -1);
    window.parent.$('body').css('overflow', '');
  }

  // function thereIsAlteredCampaigns(callback) {

  //   $.ajax({
  //     url: setIntersitialUrl(),
  //     type: 'GET',
  //     data: {
  //       action: 'jc_ajax_check_if_campaign_has_changed',
  //     },
  //     success: function (response) {

  //       var restartIntervention = sessionStorage.getItem('restart-intervention');

  //       if(response.success || restartIntervention === null){
  //         sessionStorage.setItem('restart-intervention', 'true')
  //         restartIntervention = true;
  //       }

  //       callback(restartIntervention === true);
  //     }
  //   });
  // }
});


function setIntersitialUrl(){
  var origins_intersitial = [
    "https://jornaldocarro.estadao.com.br",
    "https://jornaldocarro-temp.sydle.com",
    "https://jornaldocarro.sydle.com",
    "https://estradao.estadao.com.br",
    "https://estradao.sydle.com",
    "http://dev.jornaldocarro",
    "http://dev.estradao"
  ];

  var url_intersitial;
  if(origins_intersitial.includes(window.origin)){
    url_intersitial = window.origin  + '/wp-admin/admin-ajax.php';
  }
  else{
    url_intersitial = 'https://jornaldocarro.estadao.com.br/wp-admin/admin-ajax.php';
  }

  return url_intersitial;
}
